import { isEmpty } from "lodash";
import { useOutletContext } from "react-router-dom";
// components
import MainPageLayouts, { TMainPageLayouts } from "@/components/MainPageLayouts";
// hooks
import useContent from "@/hooks/useContent";
// enums
import ELayoutType from "@/cms/enums/ELayoutType";
import EContentType from "@/cms/enums/EContentType";
// types
import { TMainPageLayoutV3 } from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
// types
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
import TClientContentDetail from "@/cms/types/TClientContentDetail";
import TClientPageDetail from "@/cms/types/TClientPageDetail";


const MNPGRenderComponents = (props:{templates:TClientMainPageItemList[], mapLayoutName:string, parentId:string, allowedComponent?:TMainPageLayouts[], params?:any, Wrapper?:any}) => {
    const { _hideLoader } = useOutletContext<TOutletContext>();
    const components = props.templates.filter((item) => item.parentId === props.parentId && item.mapLayoutName === props.mapLayoutName);

    if ( !components || !props.templates || !props.mapLayoutName || !props.parentId ) return null;

    setTimeout(() => { _hideLoader(); }, 100);

    return components.map((item) => {
        const layout = item.layouts.find((item) => item.layoutType === ELayoutType.MAIN_PAGE);
        const Layout = MainPageLayouts?.[layout?.layoutName as string];
        if ( layout && Layout && (props.allowedComponent === undefined||props.allowedComponent.includes(layout.layoutName as TMainPageLayouts)) ) {
            if ( props.Wrapper ) {
                return <props.Wrapper key={item.id}><Layout templates={props.templates} template={item} params={props.params} /></props.Wrapper>
            }
            return <Layout key={item.id} templates={props.templates} template={item} params={props.params}  />
        }
        return null;
    });
}

const MNPGRenderPageComponents = ( props:{ templates:TClientMainPageItemList[], mapLayoutName:string, contentId:string, contentDetails:TClientContentDetail|TClientPageDetail } ) => {
    let components = props.templates.filter((item) => item.mapLayoutName === props.mapLayoutName && item.contentId === props.contentId && ( props.contentDetails.contentType === EContentType.CATEGORY ? item.layouts.map((x) => x.layoutType).includes(ELayoutType.SHOWROOM) : true ) && item.parentId === null );
    if ( isEmpty(components) )
        components = props.templates.filter((item) => item.mapLayoutName === props.mapLayoutName && (item.contentId === props.contentId || item.contentId === props.contentDetails.contentId) && ( props.contentDetails.contentType === EContentType.CATEGORY ? item.layouts.map((x) => x.layoutType).includes(ELayoutType.SHOWROOM) : !item.layouts.map((x) => x.layoutType).includes(ELayoutType.SHOWROOM) ) && item.parentId === null );
    
    if ( !components || !props.templates ) return null;

    return components.map((item) => {
        const layout = item.layouts.find((item) => item.layoutType === ELayoutType.MAIN_PAGE);
        const Layout = MainPageLayouts?.[layout?.layoutName as string];
        if ( Layout ) return <Layout key={item.id} templates={props.templates} template={item} params={{contentDetails: props.contentDetails}} />
        return null;
    })
}

const MNPGRenderPage = (props:{templates:TClientMainPageItemList[], mapLayoutName:string, contentId:string}) => {
    const { _showLoader } = useOutletContext<TOutletContext>();
    _showLoader();

    const unqKey = props.contentId.split("-")[4];
    const contentDetails = useContent({unqKey:`${unqKey}CD`, id:props.contentId});
    if ( !contentDetails ) return null;

    return <MNPGRenderPageComponents templates={props.templates} mapLayoutName={props.mapLayoutName} contentId={props.contentId} contentDetails={contentDetails} />
}

const MNPG = ( props:TMainPageLayoutV3 ) => {
    const { templates, mapLayoutName, parentId, contentId, allowedComponent, params, Wrapper } = props;

    if ( templates && mapLayoutName && parentId ) {
        return <MNPGRenderComponents templates={templates} mapLayoutName={mapLayoutName} parentId={parentId} allowedComponent={allowedComponent} params={params} Wrapper={Wrapper} />
    }
    else if ( templates && mapLayoutName && contentId ) {
        return <MNPGRenderPage templates={templates} mapLayoutName={mapLayoutName} contentId={contentId} />
    }
    
    return null;
}

export default MNPG;
